import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styles from './AppDashItem.module.less';
import classNames from 'classnames';
import _ from 'lodash';
import {Link} from 'react-router-dom';
import {AppstoreOutlined, PieChartOutlined} from '@/icons';
import {ArrowRightOutlined, PictureOutlined} from '@ant-design/icons';
import {getAppRoles} from '@/api/apps';
import {Row, Col, Avatar} from 'antd';
import {getSendMsgHistory, getReceiveMsgHistory} from '@/api/message';
import {getComment, getCommentGroupByNews} from '@/api/comment';
import {getAppManager} from '@/api/apptag';
import {getMediasCount} from '@/api/media';

export default function AppDashItem({title, appId, logo, beginTime1, beginTime7, endTime}) {
    useEffect(() => {
        getAppMgr();
        getMsgSend(false);
        getMsgSend();
        getMsgReceive(false);
        getMsgReceive();
        getComments();
        getComments(false);
        getCommentNews();
        getCommentNews(false);
        // getMembers();
        getMedias();
    }, []);
    const [appMgr, setAppMgr] = useState([]);
    const [sendMsgTotal, setSendMsgTotal] = useState(0);
    const [sendMsgTodayTotal, setSendMsgTodayTotal] = useState(0);
    const [receiveMsgTotal, setReceiveMsgTotal] = useState(0);
    const [receiveMsgTodayTotal, setReceiveMsgTodayTotal] = useState(0);
    const [commentTotal, setComentTotal] = useState(0);
    const [commentTodayTotal, setComentTodayTotal] = useState(0);
    const [commentNewsTotal, setComentNewsTotal] = useState(0);
    const [commentNewsTodayTotal, setComentNewsTodayTotal] = useState(0);
    const [members, setMembers] = useState(0);
    const [medias, setMedias] = useState({});

    function getAppMgr() {
        getAppManager(appId).then(res => {
            console.log(res);
            let arr = res.data;
            if (arr.length > 6) {
                arr.splice(5, arr.length - 5);
                console.log('arr', arr);
                arr = [...arr, {avatar: '...', userName: '...'}];
            }
            setAppMgr(arr);
        });
    }

    function getMsgSend(isToday = true) {
        getSendMsgHistory(appId, isToday ? beginTime1 : beginTime7, endTime).then(res => {
            isToday ? setSendMsgTodayTotal(res.data.total) : setSendMsgTotal(res.data.total);
        });
    }

    function getMsgReceive(isToday = true) {
        getReceiveMsgHistory(appId, isToday ? beginTime1 : beginTime7, endTime).then(res => {
            isToday ? setReceiveMsgTodayTotal(res.data.total) : setReceiveMsgTotal(res.data.total);
        });
    }

    function getComments(isToday = true) {
        getComment(appId, isToday ? beginTime1 : beginTime7, endTime).then(res => {
            isToday ? setComentTodayTotal(res.data.total) : setComentTotal(res.data.total);
        });
    }

    function getCommentNews(isToday = true) {
        getCommentGroupByNews(appId, isToday ? beginTime1 : beginTime7, endTime).then(res => {
            isToday ? setComentNewsTodayTotal(res.data.total) : setComentNewsTotal(res.data.total);
        });
    }

    // function getMembers() {
    //     getAppMembers(appId).then(res => {
    //         setMembers(res.data);
    //     });
    // }

    function getMedias() {
        getMediasCount(appId).then(res => {
            setMedias(res.data);
        });
    }

    return (
        <div className={styles.container}>
            <div className={classNames(styles.content, styles.left)}>
                <div className={styles.title}>
                    <div>
                        <AppstoreOutlined />
                        &nbsp;&nbsp;{title}
                    </div>
                    <div className={styles.sub}>近七天</div>
                </div>
                <div className={styles.overview}>
                    <Link to={`/apps/${appId}`}>
                        <Avatar className={styles.avatar} src={logo} />
                    </Link>
                    <div className={styles.block}>
                        <Link to={`/apps/${appId}/comments`}>
                            <div className={styles.value}>{commentTotal + commentNewsTotal}</div>
                            <div className={styles.label}>已接受留言</div>
                        </Link>
                    </div>
                    <div className={styles.block}>
                        <Link to={`/apps/${appId}/msg-history/received`}>
                            <div className={styles.value}>{receiveMsgTotal}</div>
                            <div className={styles.label}>已接受信息</div>
                        </Link>
                    </div>
                    <div className={styles.block}>
                        <Link to={`/apps/${appId}/msg-history/send`}>
                            <div className={styles.value}>{sendMsgTotal}</div>
                            <div className={styles.label}>已发送消息</div>
                        </Link>
                    </div>
                </div>
                <div className={styles.user}>
                    <div className={styles.title}>应用管理员</div>
                    <Row className={styles.rowContent}>
                        {appMgr.map((mgr, i) => (
                            <Col span={8} className={styles.col} key={i}>
                                {mgr.avatar !== '...' && (
                                    <Avatar src={mgr.avatar} className={styles.avatar} />
                                )}
                                &nbsp;&nbsp;{mgr.name}
                            </Col>
                        ))}
                    </Row>
                </div>
                <div className={styles.icon}>
                    <ArrowRightOutlined />
                </div>
            </div>
            <div className={classNames(styles.content, styles.right)}>
                <div className={styles.container}>
                    <div className={styles.title}>
                        <PieChartOutlined />
                        &nbsp;&nbsp;数据管理
                    </div>
                    <Row className={styles.rowContent}>
                        <Col span={8}>
                            <div className={styles.label}>今日已发送消息</div>
                            <div className={styles.value}>{sendMsgTodayTotal}</div>
                        </Col>
                        <Col span={8}>
                            <div className={styles.label}>今日已接受消息</div>
                            <div className={styles.value}>{receiveMsgTodayTotal}</div>
                        </Col>
                        <Col span={8}>
                            <div className={styles.label}>今日已接受留言</div>
                            <div className={styles.value}>
                                {commentTodayTotal + commentNewsTodayTotal}
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className={styles.container}>
                    <div className={styles.title}>
                        <PictureOutlined />
                        &nbsp;&nbsp;素材统计
                    </div>
                    <Row className={styles.rowContent}>
                        <Col span={4}>
                            <div className={styles.label}>图文</div>
                            <div className={styles.value}>
                                {_.isEmpty(medias) ? 0 : medias.news}
                            </div>
                        </Col>
                        <Col span={4}>
                            <div className={styles.label}>图片</div>
                            <div className={styles.value}>
                                {_.isEmpty(medias) ? 0 : medias.image}
                            </div>
                        </Col>
                        <Col span={4}>
                            <div className={styles.label}>文本</div>
                            <div className={styles.value}>
                                {_.isEmpty(medias) ? 0 : medias.text}
                            </div>
                        </Col>
                        <Col span={4}>
                            <div className={styles.label}>语音</div>
                            <div className={styles.value}>
                                {_.isEmpty(medias) ? 0 : medias.voice}
                            </div>
                        </Col>
                        <Col span={4}>
                            <div className={styles.label}>视频</div>
                            <div className={styles.value}>
                                {_.isEmpty(medias) ? 0 : medias.video}
                            </div>
                        </Col>
                        {/*<Col span={4}>*/}
                        {/*    <div className={styles.label}>文件</div>*/}
                        {/*    <div className={styles.value}>*/}
                        {/*        {_.isEmpty(medias) ? 0 : medias.file}*/}
                        {/*    </div>*/}
                        {/*</Col>*/}
                    </Row>
                </div>
            </div>
        </div>
    );
}

AppDashItem.propTypes = {
    title: PropTypes.string,
    appId: PropTypes.string,
    logo: PropTypes.string,
    beginTime1: PropTypes.number,
    beginTime7: PropTypes.number,
    endTime: PropTypes.number,
};
